<template>
  <dashboard-chart-card
    title="Resumen de recordatorios"
    @handleDownloadClick="downloadScheduleChart"
  >
    <template #info>
      <a-popover
        trigger="hover"
        class="popover"
        placement="bottomRight"
        :overlayStyle="{ width: '250px' }"
      >
        <template #title>
          <span class="titlePopover">Resumen de recordatorios</span>
        </template>

        <template #content>
          <div class="content">
            Visualiza y descarga la cantidad de recordatorios creados por tus usuarios.
          </div>
        </template>
        <InfoCircleOutlined class="info-circle" />
      </a-popover>
    </template>

    <div class="info-wrapper">
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        class="user_selector"
        v-model:value="userId"
        @change="handleChange"
        :options="selectOptions"
      />

      <p>Total de recordatorios: {{ totalReminders }}</p>
    </div>

    <apexcharts :height="250" type="polarArea" :options="chartOptions" :series="series" />
  </dashboard-chart-card>
</template>

<script>
import { ref, computed } from "vue";
import VueApexCharts from "vue3-apexcharts";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { fetchScheduleResume } from "../../services";

import DashboardChartCard from "../cards/DashboardChartCard.vue";
import { downloadResumeSchedule } from "@/app/dashboard/services/";

export default {
  components: {
    DashboardChartCard,
    apexcharts: VueApexCharts,
    InfoCircleOutlined,
  },
  props: {
    users: {
      required: true,
      type: Object,
    },
    filters: {
      required: true,
      type: Object,
    },
  },
  setup(props, context) {
    const userId = ref("");
    const totalReminders = ref(0);
    const series = ref([]);

    const selectOptions = computed(() => [
      { value: "", label: "Todos los usuarios" },
      ...props.users.map((user) => ({ value: user.id, label: user.fullname })),
    ]);

    const chartOptions = {
      chart: {
        type: "polarArea",
      },
      labels: ["Completados", "Pendientes", "Vencidos"],
      stroke: {
        width: 2,
        curve: "smooth",
      },
      colors: ["#B7EB8F", "#FFE58F", "#FFA39E"],
      fill: {
        opacity: 0.8,
      },
      legend: {
        position: "left",
        offsetY: 80,
        formatter: function (seriesName, opts) {
          return [`${seriesName}: ${opts.w.globals.series[opts.seriesIndex]}`];
        },
      },
      yaxis: {
        labels: {
          formatter: (val) => (val > 5 ? val : Number(val.toFixed(1))),
        },
      },
    };

    const handleChange = () => {
      fetchData();
    };

    const fetchData = async () => {
      if (!props.filters?.startDate) return;

      const data = await fetchScheduleResume(userId.value, props.filters);

      const { total_schedules, total_closed, total_pending, total_expired } = data;

      totalReminders.value = total_schedules;
      series.value = [total_closed, total_pending, total_expired];
    };

    context.expose({ fetchData });

    return {
      userId,
      totalReminders,
      series,
      selectOptions,
      chartOptions,
      handleChange,
    };
  },
  methods: {
    async downloadScheduleChart() {
      await downloadResumeSchedule(this.userId, this.filters);
    },
  },
};
</script>

<style lang="sass" scoped>
.info-wrapper
  position: absolute
  left: 30px
  top: 20px
  z-index: 2

.user_selector
  width: 180px

p
  color: $gray-9
  margin-top: 20px
  margin-left: 10px
  font-size: 12px

.popover
  margin-right: 20px

.info-circle
  font-size: 14px
  color: #51555A

.content
  font-weight: 300
  color: $gray-8

.titlePopover
  font-size: 16px
  font-weight: 600
</style>
